import { Button, ButtonProps } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";

export type TToggleStateChange = (e:React.MouseEventHandler|undefined, open:boolean) => void
export type TToggleButtonProps = ButtonProps&{
    open?:boolean,
    children:React.ReactElement|React.ReactElement[], 
    onToggle?:TToggleStateChange
}
export default forwardRef((props:TToggleButtonProps, ref:any) => {
    const {open:isOpen,children,onToggle,onClick,...buttonProps} = props
    const [open,setOpen] = useState<boolean>(isOpen || false)
    const toggle = (e:any) => {
        onClick?.(e)
        setOpen(!open)
        onToggle?.(e, !open)
    }
    useEffect(() => {
        if (isOpen!=open) setOpen(isOpen||false)
    }, [isOpen])
    return <Button className={"toggle" + (open ? " open" : "")} {...buttonProps} onClick={toggle} ref={ref}>
        {children}
    </Button>
})